import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { UserContext } from "./UserContext";
import TestataAdmin from "./partials/TestataAdmin";
import Footer from "./partials/Footer";
import moment from 'moment'; // Importa moment.js
import 'moment/locale/it'; // Importa il locale italiano

function UtenteAdmin() {
  const { userData } = useContext(UserContext);
  const { id } = useParams(); 
  const [utente, setUtente] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({});
  const [error, setError] = useState(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false); 
  const [showSuccessoMessage, setShowSuccessoMessage] = useState(false); 
  const [copiato, setCopiato] = useState(false);

  // Definizione della funzione fetchCliente FUORI da useEffect
  const fetchUtente = async () => { 
    try {        
      const token = localStorage.getItem("token");
      const response = await fetch(
        `/api/utente/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );

      if (response.ok) {
        const data = await response.json();
        data.attivo = data.attivo === true;
        data.mostraStripe = data.mostraStripe === true;
        data.formazioneObbligatoria = data.formazioneObbligatoria === true;
        setUtente(data);
        setFormData(data); // Inizializza formData con i dati del cliente        
      } else {
        throw new Error("Errore nel recupero dell'anagrafica");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchUtente();
  }, [id]);
  
   const province = [
    { sigla: 'AG', nome: 'Agrigento' },
    { sigla: 'AL', nome: 'Alessandria' },
    { sigla: 'AN', nome: 'Ancona' },
    { sigla: 'AO', nome: 'Aosta' },
    { sigla: 'AR', nome: 'Arezzo' },
    { sigla: 'AP', nome: 'Ascoli Piceno' },
    { sigla: 'AT', nome: 'Asti' },
    { sigla: 'AV', nome: 'Avellino' },
    { sigla: 'BA', nome: 'Bari' },
    { sigla: 'BT', nome: 'Barletta-Andria-Trani' },
    { sigla: 'BL', nome: 'Belluno' },
    { sigla: 'BN', nome: 'Benevento' },
    { sigla: 'BG', nome: 'Bergamo' },
    { sigla: 'BI', nome: 'Biella' },
    { sigla: 'BO', nome: 'Bologna' },
    { sigla: 'BZ', nome: 'Bolzano' },
    { sigla: 'BS', nome: 'Brescia' },
    { sigla: 'BR', nome: 'Brindisi' },
    { sigla: 'CA', nome: 'Cagliari' },
    { sigla: 'CL', nome: 'Caltanissetta' },
    { sigla: 'CB', nome: 'Campobasso' },
    { sigla: 'CI', nome: 'Carbonia-Iglesias' },
    { sigla: 'CE', nome: 'Caserta' },
    { sigla: 'CT', nome: 'Catania' },
    { sigla: 'CZ', nome: 'Catanzaro' },
    { sigla: 'CH', nome: 'Chieti' },
    { sigla: 'CO', nome: 'Como' },
    { sigla: 'CS', nome: 'Cosenza' },
    { sigla: 'CR', nome: 'Cremona' },
    { sigla: 'KR', nome: 'Crotone' },
    { sigla: 'CN', nome: 'Cuneo' },
    { sigla: 'EN', nome: 'Enna' },
    { sigla: 'FM', nome: 'Fermo' },
    { sigla: 'FE', nome: 'Ferrara' },
    { sigla: 'FI', nome: 'Firenze' },
    { sigla: 'FG', nome: 'Foggia' },
    { sigla: 'FC', nome: 'Forlì-Cesena' },
    { sigla: 'FR', nome: 'Frosinone' },
    { sigla: 'GE', nome: 'Genova' },
    { sigla: 'GO', nome: 'Gorizia' },
    { sigla: 'GR', nome: 'Grosseto' },
    { sigla: 'IM', nome: 'Imperia' },
    { sigla: 'IS', nome: 'Isernia' },
    { sigla: 'SP', nome: 'La Spezia' },
    { sigla: 'AQ', nome: "L'Aquila" },
    { sigla: 'LT', nome: 'Latina' },
    { sigla: 'LE', nome: 'Lecce' },
    { sigla: 'LC', nome: 'Lecco' },
    { sigla: 'LI', nome: 'Livorno' },
    { sigla: 'LO', nome: 'Lodi' },
    { sigla: 'LU', nome: 'Lucca' },
    { sigla: 'MC', nome: 'Macerata' },
    { sigla: 'MN', nome: 'Mantova' },
    { sigla: 'MS', nome: 'Massa-Carrara' },
    { sigla: 'MT', nome: 'Matera' },
    { sigla: 'ME', nome: 'Messina' },
    { sigla: 'MI', nome: 'Milano' },
    { sigla: 'MO', nome: 'Modena' },
    { sigla: 'MB', nome: 'Monza e della Brianza' },
    { sigla: 'NA', nome: 'Napoli' },
    { sigla: 'NO', nome: 'Novara' },
    { sigla: 'NU', nome: 'Nuoro' },
    { sigla: 'OG', nome: 'Ogliastra' },
    { sigla: 'OT', nome: 'Olbia-Tempio' },
    { sigla: 'OR', nome: 'Oristano' },
    { sigla: 'PD', nome: 'Padova' },
    { sigla: 'PA', nome: 'Palermo' },
    { sigla: 'PR', nome: 'Parma' },
    { sigla: 'PV', nome: 'Pavia' },
    { sigla: 'PG', nome: 'Perugia' },
    { sigla: 'PU', nome: 'Pesaro e Urbino' },
    { sigla: 'PE', nome: 'Pescara' },
    { sigla: 'PC', nome: 'Piacenza' },
    { sigla: 'PI', nome: 'Pisa' },
    { sigla: 'PT', nome: 'Pistoia' },
    { sigla: 'PN', nome: 'Pordenone' },
    { sigla: 'PZ', nome: 'Potenza' },
    { sigla: 'PO', nome: 'Prato' },
    { sigla: 'RG', nome: 'Ragusa' },
    { sigla: 'RA', nome: 'Ravenna' },
    { sigla: 'RC', nome: 'Reggio Calabria' },
    { sigla: 'RE', nome: 'Reggio Emilia' },
    { sigla: 'RI', nome: 'Rieti' },
    { sigla: 'RN', nome: 'Rimini' },
    { sigla: 'RM', nome: 'Roma' },
    { sigla: 'RO', nome: 'Rovigo' },
    { sigla: 'SA', nome: 'Salerno' },
    { sigla: 'VS', nome: 'Medio Campidano' },
    { sigla: 'SS', nome: 'Sassari' },
    { sigla: 'SV', nome: 'Savona' },
    { sigla: 'SI', nome: 'Siena' },
    { sigla: 'SR', nome: 'Siracusa' },
    { sigla: 'SO', nome: 'Sondrio' },
    { sigla: 'TA', nome: 'Taranto' },
    { sigla: 'TE', nome: 'Teramo' },
    { sigla: 'TR', nome: 'Terni' },
    { sigla: 'TO', nome: 'Torino' },
    { sigla: 'TP', nome: 'Trapani' },
    { sigla: 'TN', nome: 'Trento' },
    { sigla: 'TV', nome: 'Treviso' },
    { sigla: 'TS', nome: 'Trieste' },
    { sigla: 'UD', nome: 'Udine' },
    { sigla: 'VA', nome: 'Varese' },
    { sigla: 'VE', nome: 'Venezia' },
    { sigla: 'VB', nome: 'Verbano-Cusio-Ossola' },
    { sigla: 'VC', nome: 'Vercelli' },
    { sigla: 'VR', nome: 'Verona' },
    { sigla: 'VV', nome: 'Vibo Valentia' },
    { sigla: 'VI', nome: 'Vicenza' },
    { sigla: 'VT', nome: 'Viterbo' },
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleChangeBool = (e) => {
    const { name, checked } = e.target; // Ottieni il valore checked (booleano)
    setFormData({ ...formData, [name]: checked }); // Aggiorna lo stato con il valore booleano
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/utente/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        credentials: 'include',
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setEditMode(false);        
        fetchUtente(); // Ricarica i dati aggiornati del cliente
        setShowSuccessMessage(true);
        // Nascondi il messaggio dopo un breve ritardo (opzionale)
        setTimeout(() => {
        setShowSuccessMessage(false);
        }, 3000); // Nascondi dopo 3 secondi
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Errore durante il salvataggio');
      }
    } catch (err) {
      console.error('Errore durante il salvataggio:', err);
      setError('Si è verificato un errore durante il salvataggio');
    }
  };
  
  const handleCopiaTesto = async () => {
    if (!navigator.clipboard) {
      // Fallback per browser meno recenti (opzionale, ma buona pratica)
      console.error('L\'API Clipboard non è supportata da questo browser.');
      // Potresti implementare un fallback manuale qui se necessario
      return;
    }
    try {
      await navigator.clipboard.writeText(formData.tupla); // Copia il testo negli appunti
      setCopiato(true);

      // Resetta lo stato "copiato" dopo un breve periodo per feedback visivo
      setTimeout(() => {
        setCopiato(false);
      }, 2000); // Il messaggio "Copiato!" scompare dopo 2 secondi

    } catch (err) {
      console.error('Errore durante la copia della password: ', err);
      // Potresti mostrare un messaggio di errore all'utente
    }
  };

  return (
    <>
      <section className="main_content dashboard_part">
        <div className='className="container-fluid g-0'>            
            <TestataAdmin userData={userData} />
        </div>
        <div className="main_content_iner ">
          <div className="container-fluid plr_30 body_white_bg pt_30">
            <div className="row justify-content-center">
              <div className="col-lg-12">
                <div className="white_box_tittle list_header">
                  <h4>Profilo dell'Attività/Utente</h4>                  
                  {!editMode && ( // Mostra il pulsante "Modifica" solo se non sei in modalità modifica
                    <button className="btn btn-outline-warning btn-sm" onClick={() => setEditMode(true)}>
                      Modifica
                    </button>
                  )}
                </div>
                {error && <p className="error-message">{error}</p>}
                {utente ? (
                  <form onSubmit={handleSubmit}>
                    <div className="col-12 mb_30">
                      <div className="row">                        
                        <div className="form-group col-md-1 cols-sm-6 mb_20">
                            <label htmlFor="ragioneSociale">Attivo:</label><br />
                            <input
                                type="checkbox"
                                id="attivo"
                                name="attivo"
                                checked={formData.attivo}
                                value="true"
                                onChange={handleChangeBool}
                                disabled={!editMode}
                            />
                        </div>                        
                        <div className="form-group col-md-3 cols-sm-12 mb_20">
                            <label htmlFor="ragioneSociale">Ragione Sociale:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="ragSociale"
                                name="ragSociale"
                                value={formData.ragSociale}
                                onChange={handleChange}
                                disabled={!editMode} // Disabilita il campo se non sei in modalità modifica
                            />
                        </div>
                        <div className="form-group col-md-4 cols-sm-12 mb_20">
                            <label htmlFor="nome">Nome:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="nome"
                                name="nome"
                                value={formData.nome}
                                onChange={handleChange}
                                disabled={!editMode}
                            />
                        </div>
                        <div className="form-group col-md-4 cols-sm-12 mb_20">
                            <label htmlFor="cognome">Cognome:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="cognome"
                                name="cognome"
                                value={formData.cognome}
                                onChange={handleChange}
                                disabled={!editMode}
                            />
                        </div>
                      </div>
                      <div className="row">
                        <div className="form-group col-md-6 cols-sm-12 mb_20">
                            <label htmlFor="indirizzo">Indirizzo:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="indirizzo"
                                name="indirizzo"
                                value={formData.indirizzo}
                                onChange={handleChange}
                                disabled={!editMode}
                            />
                        </div>
                      
                        <div className="form-group col-md-6 cols-sm-12 mb_20">
                          <label htmlFor="comune">Comune:</label>
                          <input
                              type="text"
                              className="form-control"
                              id="comune"
                              name="comune"
                              value={formData.comune}
                              onChange={handleChange}
                              disabled={!editMode}
                          />
                        </div>
                      </div>
                      <div className="row">
                        
                        <div className="form-group col-md-6 cols-sm-12 mb_20">
                          <label htmlFor="comune">Regione:</label>
                          <input
                              type="text"
                              className="form-control"
                              id="regione"
                              name="regione"
                              value={formData.regione}
                              onChange={handleChange}
                              disabled={!editMode}
                          />
                        </div>
                        <div className="form-group col-md-3 cols-sm-6 mb_20">
                            <label htmlFor="prov">Prov:</label>
                            <select
                              className="form-select form-control"
                              id="prov"
                              name="prov"
                              value={formData.prov.toUpperCase()} // Imposta il valore in maiuscolo
                              onChange={handleChange}
                              disabled={!editMode}
                            >
                            {province.map(provincia => (
                              <option key={provincia.sigla} value={provincia.sigla.toUpperCase()}>
                                {provincia.nome.charAt(0).toUpperCase() + provincia.nome.slice(1)}
                              </option>
                            ))}
                            </select>
                        </div>
                        <div className="form-group col-md-3 cols-sm-6 mb_20">
                            <label htmlFor="cap">CAP:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="cap"
                                name="cap"
                                value={formData.cap}
                                onChange={handleChange}
                                disabled={!editMode}
                            />
                        </div>
                      </div>
                      <div className="row">
                        <div className="form-group col-md-4 cols-sm-12 mb_20">
                            <label htmlFor="tel">Telefono:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="tel"
                                name="tel"
                                value={formData.tel}
                                onChange={handleChange}
                                disabled={!editMode} // Disabilita il campo se non sei in modalità modifica
                            />
                        </div>
                        <div className="form-group col-md-4 cols-sm-12 mb_20">
                            <label htmlFor="cell">Cellulare:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="cell"
                                name="cell"
                                value={formData.cell}
                                onChange={handleChange}
                                disabled={!editMode}
                            />
                        </div>
                        <div className="form-group col-md-4 cols-sm-12 mb_20">
                            <label htmlFor="whatsapp">Sito web &nbsp; [http(s)://nomeazienda.ext]:</label><br />
                            <input
                                type="text"
                                className="form-control"
                                id="url"
                                name="url"
                                value={formData.url}
                                onChange={handleChange}
                                disabled={!editMode}
                            />
                        </div>
                      </div>
                      <div className="row">
                        <div className="form-group col-md-4 cols-sm-12 mb_20">
                            <label htmlFor="mail">Indirizzo e-mail:</label>
                            <input
                                type="mail"
                                className="form-control"
                                id="mail"
                                name="mail"
                                value={formData.mail}
                                onChange={handleChange}
                                disabled={!editMode} // Disabilita il campo se non sei in modalità modifica
                            />
                        </div>                        
                        <div className="form-group col-md-4 cols-sm-12 mb_20">
                            <label htmlFor="codFisc">Codice Fiscale:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="codFisc"
                                name="codFisc"
                                value={formData.codFisc}
                                onChange={handleChange}
                                disabled={!editMode} // Disabilita il campo se non sei in modalità modifica
                            />
                        </div>
                        <div className="form-group col-md-4 cols-sm-12 mb_20">
                            <label htmlFor="piva">Partita IVA:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="piva"
                                name="piva"
                                value={formData.piva}
                                onChange={handleChange}
                                disabled={!editMode}
                            />
                        </div> 
                     <div className="row">
                        <div className="form-group col-md-4 cols-sm-12 mb_20">
                          {!editMode && ( // Mostra il pulsante "Salva" solo se sei in modalità modifica
                          <>
                            <label htmlFor="mail">Password di accesso dell'Utente:&nbsp; </label>
                            <strong style={{color: '#4C267B'}}>{formData.tupla}</strong>
                            <button
                              onClick={handleCopiaTesto}
                              disabled={copiato}
                              title={copiato ? 'Copiata!' : 'Copia Password'} // Utile per accessibilità
                              className="btn btn-lg text-dark"
                              style={{ marginLeft: '6px', border: 'none', cursor: 'pointer' }}
                            >
                              {copiato ? <i className="fa fa-check"></i> : <i className="fa fa-copy"></i>}
                            </button> 
                          </>
                          )}                         
                        </div>
                        <div className="form-group col-md-8 cols-sm-8 mb_20" style={{textAlign: 'right'}}>
                             {showSuccessMessage && editMode && ( // Mostra il messaggio solo se showSuccessMessage è true e siamo in editMode
                                <div className="alert alert-success mt_20" role="alert">Dati aggiornati con successo!</div>
                            )}
                            {editMode && ( // Mostra il pulsante "Salva" solo se sei in modalità modifica
                                <button type="submit" className="btn btn-primary mt_20">
                                    Salva
                                </button>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  </form>
                ) : (
                  <p>Caricamento dei tuoi dati...</p>
                )}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default UtenteAdmin;
